import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero, SectionHead } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { BusinessPillars } from "@/components/site/BusinessPillars";
import { ENQUIRY_TYPES } from "@/config/site";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Approach() {
  usePageMeta("Business Approach", "How Suvirika Retail Pvt Ltd approaches market connectivity, consumer categories, retail enablement and brand development.");
  return (
    <>
      <PageHero
        eyebrow="Our Business Approach"
        lines={["Distinct Brands.", <em key="i" className="italic font-light text-sky-ink">Connected</em>, "Opportunities."]}
        intro="Four ideas shape how we build and grow our portfolio. They describe our direction; each brand applies them according to its own category and stage of development."
        testId="approach-hero"
      />
      <section className="pb-24 md:pb-32">
        <div className="container-x"><BusinessPillars /></div>
      </section>
      <section className="bg-[var(--paper-2)] py-24 md:py-32">
        <div className="container-x grid gap-14 lg:grid-cols-12 lg:items-center">
          <Reveal className="lg:col-span-6">
            <div className="relative aspect-[4/3] overflow-hidden rounded-tr-[180px]">
              <img src="/images/warehouse-team.jpg" alt="Two people handling a package inside a stocked warehouse" loading="lazy" className="h-full w-full object-cover" />
            </div>
          </Reveal>
          <div className="lg:col-span-6">
            <SectionHead eyebrow="Working with partners" lines={["Where we", <em key="i" className="italic font-light text-rose-ink">collaborate.</em>]} className="!grid-cols-1" />
            <ul className="mt-10 border-t hairline">
              {ENQUIRY_TYPES.map((t, i) => (
                <Reveal as="li" key={t} delay={i * 0.06} className="flex items-baseline gap-5 border-b hairline py-5">
                  <span className="font-mono-label text-xs text-[var(--ink-2)]">0{i + 1}</span>
                  <span className="text-lg">{t}</span>
                </Reveal>
              ))}
            </ul>
            <Reveal className="mt-10">
              <Link to="/partner-with-us" className="btn-ink" data-testid="approach-partner-btn">Partner With Us <ArrowUpRight size={18} /></Link>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
